import { useState } from "react";
import { Box, Button, Container, Flashbar, FormField, Header, Input, SpaceBetween } from "@cloudscape-design/components";
import { setApiKey } from "./apiKey";
import { useDocumentTitle } from "./useDocumentTitle";

interface LoginPageProps {
  ssoEnabled: boolean;
  onSsoLogin: () => void;
  ssoError: string | null;
}

export default function LoginPage({ ssoEnabled, onSsoLogin, ssoError }: LoginPageProps) {
  const [apiKeyValue, setApiKeyValue] = useState("");
  useDocumentTitle("Login");

  const saveApiKey = () => {
    if (!apiKeyValue.trim()) return;
    setApiKey(apiKeyValue.trim());
    window.location.reload();
  };

  const apiKeyForm = (
    <SpaceBetween size="s">
      <FormField label="API Key">
        <Input type="password" value={apiKeyValue} onChange={({ detail }) => setApiKeyValue(detail.value)} />
      </FormField>
      <Button variant="primary" onClick={saveApiKey}>Save</Button>
    </SpaceBetween>
  );

  return (
    <Box margin={{ top: "xxxl" }} padding="l">
      <div style={{ maxWidth: 400, margin: "0 auto" }}>
        <SpaceBetween size="l">
          {ssoError && (
            <Flashbar items={[{ type: "error", content: ssoError, dismissible: false }]} />
          )}
          <Container header={<Header variant="h1">IT Project Management</Header>}>
            <SpaceBetween size="l">
              {ssoEnabled ? (
                <Button variant="primary" onClick={onSsoLogin} fullWidth>Sign in with Microsoft</Button>
              ) : (
                apiKeyForm
              )}
            </SpaceBetween>
          </Container>
        </SpaceBetween>
      </div>
    </Box>
  );
}
